import { Link, useLocation, useHistory } from "react-router-dom";
import { Button, TwoStageButton } from "@jauntin/react-ui";
import { Selectors } from "@jauntin/reactables";
import RouteParser from "Helpers/RouteParser";
import { Card } from "react-bootstrap";
import AlertInvalidPolicy from "Features/Shared/Components/AlertInvalidPolicy";
import AlertSelectionRequired from "Features/Shared/Components/AlertSelectionRequired";
import YesNoField from "Features/Shared/Components/YesNoField";
import Breadcrumbs from "../BreadCrumbs/Breadcrumbs";
import ExcludedActivitiesList from "../ExcludedActivitiesList/ExcludedActivitiesList";
import { RxCoverageApplicationProp } from "../../Rx/RxCoverageApplication/RxCoverageApplication";

import * as FormSelectors from "../../Rx/RxCoverageApplication/Selectors/form.selector";

const EligibilityQuestions = ({
  rxCoverageApplication: [state, actions],
}: {
  rxCoverageApplication: RxCoverageApplicationProp;
}) => {
  const location = useLocation();
  const history = useHistory();

  const {
    eligibilityQuestions: { excludedActivities },
  } = FormSelectors.getRootValue(state);

  const eligibilityQuestionsControl = FormSelectors.getControl(
    state,
    "eligibilityQuestions"
  );

  const hasVisibleError = Selectors.hasControlTouchError(
    state.applicationForm,
    "eligibilityQuestions"
  );

  const buttonTouched = state.touchButtons.eligibilityQuestions;
  const eligibilityValid = eligibilityQuestionsControl.valid;
  const actionEnabled = buttonTouched || eligibilityValid;
  const disabled = hasVisibleError || (actionEnabled && !eligibilityValid);

  const showSelectionRequired =
    buttonTouched &&
    FormSelectors.getControl(state, "eligibilityQuestions.excludedActivities")
      .errors.required;

  const excludedActivitiesList = state.excludedActivities.data;

  if (!excludedActivitiesList) {
    return (
      <h1 className="py-4 text-center">
        Sorry, we encountered an unexpected error. Please try again.
      </h1>
    );
  }

  return (
    <>
      <Breadcrumbs />
      <div className="eventSelect d-flex justify-content-center">
        <div className="eventSelect card--width-lg card--main">
          <Card.Header className="border-0 pb-0">
            <div className="text-center w-100">
              <h1>Excluded objects &amp; activities</h1>
              <p className="mt-4">
                <strong>
                  The following activities or use of the following objects are
                  not covered by the policy.
                </strong>
              </p>
            </div>
          </Card.Header>
          <Card.Body className="pt-5">
            <>
              <ExcludedActivitiesList
                excludedActivities={excludedActivitiesList}
              />
              <div className="row justify-content-center mt-5">
                <div className="col-auto">
                  <AlertInvalidPolicy
                    show={eligibilityQuestionsControl.errors.eligibility}
                  />
                  {excludedActivities !== undefined && (
                    <YesNoField
                      name="eligibilityQuestions.excludedActivities"
                      className="mb-0"
                    >
                      Does your event involve anything listed above?
                    </YesNoField>
                  )}
                  <AlertSelectionRequired show={showSelectionRequired} />
                </div>
              </div>
              <div className="row justify-content-center mt-5">
                <div className="col-auto">
                  <Link
                    to={RouteParser.create(
                      location.pathname
                    ).linkToEventQuestionsPage()}
                  >
                    <Button
                      onClick={() => undefined}
                      text="Back"
                      className="btn-link"
                    />
                  </Link>
                </div>
                <div className="col-auto">
                  <TwoStageButton
                    disabled={disabled}
                    actionEnabled={actionEnabled}
                    action={() => {
                      history.replace(
                        RouteParser.create(
                          location.pathname
                        ).linkToApplicationPage()
                      );
                    }}
                    touch={() => actions.touchButton("eligibilityQuestions")}
                    text="Continue"
                    className="btn btn-primary"
                  />
                </div>
              </div>
            </>
          </Card.Body>
        </div>
      </div>
    </>
  );
};

export default EligibilityQuestions;
